import { ValidationError } from '../components/TeamCreateDialog/types';

export const validateTeamName = (teamName?: string): undefined | ValidationError => {
	if (!teamName) {
		return ValidationError.REQUIRED;
	}
	if (teamName.length > 100) {
		return ValidationError.EXCEED_MAX_LENGTH;
	}
	return undefined;
};
